// Change navbar from transparent to solid background color on scroll
$(function () {
    $(document).scroll(function () {
        var $nav = $(".fixed-top");
        $nav.toggleClass("scrolled", $(this).scrollTop() > $nav.height());
    });
});

/* FIX FOR: If user refreshes page, nav will be set to top rather than the middle of the page. */
$(function () {
    $(window).on("load scroll resize orientationchange", function () {
        if ($(window).scrollTop() > 1) {
            $(".fixed-top").addClass("scrolled");
        } else {
            $(".fixed-top").removeClass("scrolled");
        }
    });
});
